<template>
  <li class="nav-item" role="presentation">
    <a
      :class="['nav-link', active ? 'active' : '', widthclass]"
      :id="id"
      :href="href"
      :aria-controls="ariaControls"
      :aria-selected="ariaSelected"
      role="tab"
      :data-bs-toggle="pills ? 'pill' : 'tab'"
      :data-bs-target="href"
      @click.prevent="handleClick"
    >
      <slot name="title">{{ title }}</slot>
    </a>
  </li>
</template>

<script>
export default {
  name: 'TabNavItems',
  props: {
    active: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      default: ''
    },
    href: {
      type: String,
      default: '#'
    },
    ariaControls: {
      type: String,
      default: ''
    },
    ariaSelected: {
      type: [Boolean, String],
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    liClass: {
      type: String,
      default: ''
    },
    widthclass: {
      type: String,
      default: ''
    },
    pills: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleClick(e) {
      this.$emit('click', e);
      // Trigger Bootstrap tab event
      const tab = new window.bootstrap.Tab(e.target);
      tab.show();
    }
  }
}
</script>

